import { changeAccountLogo } from "../../../api/profile/changeAccountLogo";
import { getProfile } from "../../../api/profile/getProfile";
import { updateProfileInfo } from "../../../api/profile/updateProfileInfo";

export async function getCompleteSignupProfile() {
  return getProfile();
}

export async function saveCompleteSignupProfile(payload) {
  return updateProfileInfo(payload);
}

export async function saveCompleteSignupImage(base64Image) {
  return changeAccountLogo(base64Image);
}
